import {ApiClient} from "./config";

export const signInReq = async (data) => {
    return await ApiClient.post('api/v1/auth/login/', data);
}
export const signUpReq = async (data) => {
    return await ApiClient.post('api/v1/auth/signup/', data);
}
export const verifyReq = async (data) => {
    return await ApiClient.post('api/v1/auth/verify-email/', data);
}
export const resendCodeReq = async (data) => {
    return await ApiClient.post('api/v1/auth/resend-code/', data);
}
export const getUserInfo = async () => await ApiClient.get('api/v1/users/me/');